import AuFlag from '@/assets/flags/au.svg?component'
import DeFlag from '@/assets/flags/de.svg?component'
import DkFlag from '@/assets/flags/dk.svg?component'
import EsFlag from '@/assets/flags/es.svg?component'
import FiFlag from '@/assets/flags/fi.svg?component'
import FrFlag from '@/assets/flags/fr.svg?component'
import GbFlag from '@/assets/flags/gb.svg?component'
import ItFlag from '@/assets/flags/it.svg?component'
import NlFlag from '@/assets/flags/nl.svg?component'
import NoFlag from '@/assets/flags/no.svg?component'
import PlFlag from '@/assets/flags/pl.svg?component'
import SeFlag from '@/assets/flags/se.svg?component'

export const COUNTRIES_DATA = [
  {
    iso: 'DE',
    name: 'Germany',
    language: 'de',
    currency: 'EUR',
    flag: DeFlag,
  },
  {
    iso: 'DK',
    name: 'Denmark',
    language: 'da',
    currency: 'DKK',
    flag: DkFlag,
  },
  {
    iso: 'GB',
    name: 'United Kingdom',
    language: 'en',
    currency: 'GBP',
    flag: GbFlag,
  },
  {
    iso: 'FI',
    name: 'Finland',
    language: 'fi',
    currency: 'EUR',
    flag: FiFlag,
  },
  {
    iso: 'IT',
    name: 'Italy',
    language: 'it',
    currency: 'EUR',
    flag: ItFlag,
  },
  {
    iso: 'NO',
    name: 'Norway',
    language: 'no',
    currency: 'NOK',
    flag: NoFlag,
  },
  {
    iso: 'PL',
    name: 'Poland',
    language: 'pl',
    currency: 'PLN',
    flag: PlFlag,
  },
  {
    iso: 'SE',
    name: 'Sweden',
    language: 'sv',
    currency: 'SEK',
    flag: SeFlag,
  },
  {
    iso: 'ES',
    name: 'Spain',
    language: 'es',
    currency: 'EUR',
    flag: EsFlag,
  },
  {
    iso: 'FR',
    name: 'France',
    language: 'fr',
    currency: 'EUR',
    flag: FrFlag,
  },
  {
    iso: 'NL',
    name: 'Netherlands',
    language: 'nl',
    currency: 'EUR',
    flag: NlFlag,
  },
  {
    iso: 'AU',
    name: 'Australia',
    language: 'en',
    currency: 'AUD',
    flag: AuFlag,
  },
]

export const CURRENCY_MAP = {
  DE: 'EUR',
  DK: 'DKK',
  GB: 'GBP',
  FI: 'EUR',
  IT: 'EUR',
  NO: 'NOK',
  PL: 'PLN',
  SE: 'SEK',
  ES: 'EUR',
  FR: 'EUR',
  US: 'USD',
  NL: 'EUR',
  AU: 'AUD',
}

export const EU_COUNTRIES = [
  'BE',
  'BG',
  'CZ',
  'DK',
  'DE',
  'EE',
  'IE',
  'GR',
  'ES',
  'FR',
  'HR',
  'IT',
  'CY',
  'LV',
  'LT',
  'LU',
  'HU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SI',
  'SK',
  'FI',
  'SE',
]
